import React from 'react'
import {Row, notification, Layout} from 'antd';
import Header from './components/Header'
import Footer from './components/Footer'
import {connect} from 'react-redux'
import NavLeft from './components/NavLeft'
import './style/common.less'

import {withRouter} from 'react-router-dom'
import {API_HOST_WEBSOCKET} from "./constants";
import {createWebSocket} from "./utils/websocket";
import Audioplay from "./components/AudioPlay";

import {COMMON_ROUTER, IMAGE_PATH} from "./constants";

import moment from "moment";

const {Sider} = Layout

class Admin extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      audiourl:'',

      collapsed: false,

      roleType: null,
      shopId: 0,
      openId: ''
    }

    this.connectWebSocket();
  }

  componentDidMount() {
    this.getParamsId()
  }

  getParamsId = () => {
    let storage = window.localStorage;
    let roleType = storage.getItem('ROLE_TYPE');
    let shopId = storage.getItem('SHOP_ID');
    let openId = storage.getItem('OPEN_ID');
    this.setState({
      roleType: roleType,
      shopId: shopId,
      openId: openId
    })
    // createWebSocket(this.props.history, "ws://" + API_HOST_WEBSOCKET + "/websocket/data/" + templateId);
    //建立全局websocket
    this.useWebSocketSync(shopId)
  }

  openNotification = (desc, tag) => {
    notification.open({
      key: tag,
      message: '消息提醒',
      description: desc,
      duration: 3,
      onClick: () => {
        this.props.history.push({
          pathname: COMMON_ROUTER + '/order',
          state: {
            // templateId: templateId,
            // selectedType: type,
          }
        });
        notification.close(tag)
      },
    });
  };

  saveWebSocketMsg(type, templateId) {
    if (!window.localStorage) {
      alert('浏览器不支持localstorage');
      return false;
    } else {
      var storage = window.localStorage;
      storage.setItem('templateId', templateId)
      storage.setItem('selectedType', type)
      if (storage.getItem('templateId')) {
        console.log('templateId已存储')
      }
      if (storage.getItem('selectedType')) {
        console.log('selectedType已存储')
      }
    }
  }

  onCollapse = collapsed => {
    // console.log(collapsed);
    this.setState({ collapsed });
  };

  render() {
    let {templateName, templateId} = this.state
    return (
        <Row className="container">
          <Audioplay src={this.state.audiourl}/>
          <Layout style={{ minHeight: '100vh' }}>
            <Sider collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
              <NavLeft/>
            </Sider>
            <Layout className="site-layout" style={{backgroundColor: '#ffffff'}}>
              <Header templateId={templateId} templateName={templateName}/>
              <div className="content-frame">
                {/* <Home/> */}
                {this.props.children}
              </div>
              <Footer/>
            </Layout>
          </Layout>
        </Row>
    );
  }

  connectWebSocket() {
    const _this = this;
    let websocket, lockReconnect = false;
    this.createWebSocket = (url) => {
      websocket = new WebSocket(url);
      websocket.onopen = function () {
        // console.log('onopen')
        lockReconnect = true;
        heartCheck.reset().start();
      }
      websocket.onerror = function () {
        // console.log('onerror')
        // lockReconnect = false;
        // reconnect(url);
      };
      websocket.onclose = function (e) {
        // console.log('onclose' + e.toString())
        lockReconnect = false;
        reconnect(url);
      }
      websocket.onmessage = function (event) {
        // console.log('通信')
        // console.log(event.data)
        lockReconnect = true;
        if (event.data === 'HeartBeat') {
          // console.log('通信心跳+++')
        } else {
          _this.setState({
            audiourl: IMAGE_PATH + '/assets/sound/new.wav'
          }, () => _this.openNotification(event.data + '', moment().format('X')))
          // _this.saveWebSocketMsg(data.dataType, data.mainShop)
        }
      }
    }
    let reconnect = (url) => {
      const _this = this;
      if (lockReconnect) return;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        _this.createWebSocket(url);
        lockReconnect = false;
      }, 5000);
    }
    let heartCheck = {
      timeout: 60000, //60秒
      timeoutObj: null,
      reset: function () {
        clearInterval(this.timeoutObj);
        return this;
      },
      start: function () {
        this.timeoutObj = setInterval(function () {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          //onmessage拿到返回的心跳就说明连接正常
          // if (lockReconnect) {
          //   websocket.send("HeartBeat");
          // }
        }, this.timeout)
      }
    }
    //关闭连接
    this.closeWebSocket = () => {
      // console.log('断开连接...')
      websocket && websocket.close();
    }
  }

  useWebSocketSync(key) {
    let url = "wss://" + API_HOST_WEBSOCKET + "/websocket/data/shop/" + key;//服务端连接的url
    this.createWebSocket(url)
    //在组件卸载的时候，关闭连接
    return () => {
        this.closeWebSocket();
    }
  }

  componentWillUnmount() {
    //在组件卸载的时候，关闭连接
    this.closeWebSocket();
  }
}

export default withRouter(connect()(Admin))



// WEBPACK FOOTER //
// ./src/admin.js